import request from '@/utils/request'

// 获取配置列表
export function getConfigList(params) {
  return request({
    url: '/admin/api/configs',
    method: 'get',
    params
  })
}

// 根据keys获取特定配置项（支持多个keys，用逗号分隔）
export function getConfigsByKeys(keys) {
  return request({
    url: '/api/configs',
    method: 'get',
    params: { keys }
  })
}

// 创建配置
export function createConfig(data) {
  return request({
    url: '/admin/api/configs',
    method: 'post',
    data
  })
}

// 更新配置
export function updateConfig(id, data) {
  return request({
    url: `/admin/api/configs/${id}`,
    method: 'put',
    data
  })
}

// 删除配置
export function deleteConfig(id) {
  return request({
    url: `/admin/api/configs/${id}`,
    method: 'delete'
  })
}